<template>
    <div>
        <div class="col-12 rules_section">
          <div>
            <h2 v-if="language === 'english'">{{english.RulesMenuView.h3_1}}</h2>
            <h2 v-else-if="language === 'spanish'">{{spanish.RulesMenuView.h3_1}}</h2>

            <p v-if="language === 'english'">{{english.RulesMenuView.p_1}}</p>
            <p v-else-if="language === 'spanish'">{{spanish.RulesMenuView.p_1}}</p>

            <h2 v-if="language === 'english'">{{english.RulesMenuView.h3_2}}</h2>
            <h2 v-else-if="language === 'spanish'">{{spanish.RulesMenuView.h3_2}}</h2>            

            <p v-if="language === 'english'">{{english.RulesMenuView.p_2}}</p>
            <p v-else-if="language === 'spanish'">{{spanish.RulesMenuView.p_2}}</p>

            <a v-if="language === 'english'" 
            href="https://www.nba.com/spurs/spurs-loteria-rules" 
            target="_blank">{{english.RulesMenuView.a_1}}</a>
            <a v-else-if="language === 'english'" 
            href="https://www.nba.com/spurs/spurs-loteria-rules" 
            target="_blank">{{spanish.RulesMenuView.a_1}}</a>
          </div>
        </div>
    </div>
</template>

<script>
import english from '../assets/json/languages/english.json'
import spanish from '../assets/json/languages/spanish.json'

export default {
  name: 'RulesMenuView',
  props: ['language'],
  data(){
    return{
      english, spanish
    }
  }
}
</script>
